export type InvoiceProcess = {
  endTime: Nullable<string>;
  fileName: string;
  id: number;
  invoiceId: Nullable<number>;
  orderId: number;
  startTime: Nullable<string>;
  status: InvoiceProcessStatus;
};

export enum InvoiceProcessStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}
